// tslint:disable:no-trailing-whitespace
// tslint:disable:member-ordering
import { BaseEntity } from '../base-entity';
import { Account } from './account';
import { ProximityUser } from './proximity-user';
import { Supplier } from './supplier';

/// <code-import> Place custom imports between <code-import> tags

/// </code-import>

/// <module-code> Place module level code between <module-code> tags

/// </module-code>

export class ProximityPref extends BaseEntity  {

  /// <code> Place custom code between <code> tags
  
  /// </code>

  // Generated code. Do not place code below this line.
  /** Guid key */
  id!: string;
  /** Guid FK account */
  accountId?: string;
  /** String(2000) */
  prefsJson!: string;
  /** Guid FK proximityUser */
  proximityUserId?: string;
  /** Binary */
  rowVersion!: any;
  /** Guid FK supplier */
  supplierId?: string;
  /** FK accountId */
  account!: Account;
  /** FK proximityUserId */
  proximityUser!: ProximityUser;
  /** FK supplierId */
  supplier!: Supplier;
}

